<script lang="ts">
export default {
  name: 'SpIcon'
}
</script>

<script lang="ts" setup>
import SvgIcon from './SvgIcon.vue'
import Iconify from './Iconify.vue'

interface Props {
  icon: string
  color?: string
  size?: string | number
  spin?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  color: '',
  size: 16,
  spin: false
})

const SVG_END_WITH_FLAG = '|svg'
const isSvgIcon = computed(() => props.icon?.endsWith(SVG_END_WITH_FLAG))
const getSvgIcon = computed(() => props.icon?.replace(SVG_END_WITH_FLAG, ''))
</script>

<template>
  <SvgIcon v-if="isSvgIcon" :name="getSvgIcon" :size="size" :spin="spin" />
  <Iconify v-else :icon="icon" :size="size" :spin="spin" />
</template>
